import { Stack, Typography } from '@mui/material'
import isEmpty from 'lodash/isEmpty'
import numeral from 'numeral'
import { useMemo } from 'react'

import { Fee, FeeType, Maybe } from '@/clients/utoniq-core/schema'
import { useTranslation } from '@/core'
import { Cell, CellFrame } from '@/core/architecture'

type CommissionListCellProps = {
  paymentFees?: Maybe<Fee[]>
  isKonbini?: boolean
}
export const CommissionListCell: Cell<CommissionListCellProps> = ({
  paymentFees,
  isKonbini,
}) => {
  const { t } = useTranslation('lotteryDetail')

  // 手数料を表示用にフォーマットする
  const formattedFees = useMemo(() => {
    const filteredFees = paymentFees?.filter(
      fee => fee.feeType !== FeeType.Konbini || isKonbini
    )
    if (!filteredFees || filteredFees.length === 0) {
      return [t('emptyFees', 'なし')]
    }
    return filteredFees.map(fee => {
      switch (fee.per) {
        case 'order':
          return `${fee.feeName}: ${t('feePerOrder', {
            fee: `${numeral(fee.fee).format('0,0')}`,
          })}`
        case 'item':
          return `${fee.feeName}: ${t('feePerItem', {
            fee: `${numeral(fee.fee).format('0,0')}`,
          })}`
        default:
          return null
      }
    })
  }, [t, paymentFees, isKonbini])

  if (isEmpty(formattedFees)) {
    return null
  }

  return (
    <CellFrame sx={{ pt: 3, pb: 7 }}>
      <Typography
        variant="h6"
        sx={{ bgcolor: 'grey.50', px: 2, py: 1 }}
        color="text.secondary"
      >
        {t('usageFee', '利用手数料')}
      </Typography>
      <Stack sx={{ pt: 6, px: 1 }} spacing={1}>
        <Typography color="text.secondary" variant="subtitle1">
          {t('commission', '手数料')}
        </Typography>
        <Typography variant="body2">
          {formattedFees?.map(fee => fee).join('\n')}
        </Typography>
      </Stack>
    </CellFrame>
  )
}
